export default __webpack_public_path__ + "static/media/updatelogoblue.8a46c3fc.svg";